export interface Car {
  id: string;
  brand: string;
  model: string;
  plate: string;
  chassisNumber: string;
  color: string;
  insuranceName: string;
  mileage: number | null;
  createdAt: Date;
  updatedAt: Date;
  costumerId: string;
}

export interface CarRepository {
  id: string;
  plate: string;
  brand: string;
  model: string;
  color: string;
  insurance_name: string;
  chassis_number: string;
  mileage?: number | null;
  costumer_id: string;
  created_at?: string;
}

export interface CarWithCostumer extends CarRepository {
  costumer?: {
    id: string;
    name: string;
  };
}

export function CreateNewCar(override?: Partial<Car>): Car {
  return {
    id: "",
    brand: "",
    model: "",
    plate: "",
    chassisNumber: "",
    color: "",
    insuranceName: "",
    mileage: null,
    createdAt: new Date(),
    updatedAt: new Date(),
    costumerId: "",
    ...override
  };
}

export function isValidCar(car: Car): boolean {
  return (
    car.brand !== "" &&
    car.model !== "" &&
    car.plate !== "" &&
    car.chassisNumber !== "" &&
    car.color !== "" &&
    car.insuranceName !== ""
  );
}
